// import { fabric } from 'fabric'
import shapes from './shapes'
import text from './text'
import image from './image'
import note from './note'

export default {
  shapes,
  text,
  image,
  note,

  supportsFillColour: function (object) {
    return !shapes.line.isA(object) && !shapes.arrow.isA(object) && !text.isA(object) && object.type !== 'path'
  },

  supportsBorderColour: function (object) {
    return !text.isA(object) && !note.isA(object)
  },

  supportsText: function (object) {
    return text.isA(object) || note.isA(object) || shapes.withText.isA(object)
  },

  isChildTextbox: function (object) {
    return object.type === 'textbox' && object.parent
  },

  getStrokeWidth: function (object) {
    if (shapes.withText.isA(object)) {
      return shapes.withText.getShape(object).strokeWidth
    }

    return object.strokeWidth
  }
}
